module.exports = __webpack_public_path__ + "img/M6-15012022.1ac9cd8d.png";